import * as React from 'react';
import { Box } from '../../box';

export const DropdownMenuItemIcon = ({
  children,
}: {
  children?: React.ReactNode;
}) => <Box className="w-[16px]">{children}</Box>;
